import { Component, HostListener, OnInit, Renderer2, OnDestroy, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

interface Video {
  id: number;
  title: string;
  thumbnail: string;
  video: string;
  safeUrl?: SafeResourceUrl;
  thumbnailError?: boolean;
}

interface GalleryImage {
  id: number;
  src: string;
  alt: string;
  caption: string;
}

@Component({
  selector: 'app-life-at-kalpita',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './life-at-kalpita.component.html',
  styleUrl: './life-at-kalpita.component.scss'
})
export class LifeAtKalpitaComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  // ==================== VIDEOS SECTION ====================
  trainingVideos: Video[] = [
    {
      id: 1,
      title: 'Kalpita Technologies 7th Anniversary Celebrations Highlights',
      thumbnail: 'https://img.youtube.com/vi/Ml0K_FKguI4/maxresdefault.jpg',
      video: 'https://www.youtube.com/watch?v=Ml0K_FKguI4'
    },
    {
      id: 2,
      title: '2025 Recap Kalpita Technologies! Corporate Life | Corporate Culture Wrap Up',
      thumbnail: 'https://img.youtube.com/vi/fp6B1kbY03g/maxresdefault.jpg',
      video: 'https://www.youtube.com/watch?v=fp6B1kbY03g'
    },
    {
      id: 3,
      title: 'SPARK The Best Moments of 2024! Can You Spot Yourself',
      thumbnail: 'https://img.youtube.com/vi/7kfUTOdvimw/hqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=7kfUTOdvimw&t=6s'
    },
    {
      id: 4,
      title: 'Client Visit 2022 -Cultural Activities',
      thumbnail: 'https://img.youtube.com/vi/GEFVD05ZKr8/maxresdefault.jpg',
      video: 'https://www.youtube.com/watch?v=GEFVD05ZKr8'
    },
    {
      id: 5,
      title: 'Kalpita Technologies wishes Happy Sankranti',
      thumbnail: 'https://img.youtube.com/vi/daxSnaMHgfk/hqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=daxSnaMHgfk'
    },
    {
      id: 6,
      title: 'Kalpita FUN RUN 2022',
      thumbnail: 'https://img.youtube.com/vi/g1OOjNPQb0g/maxresdefault.jpg',
      video: 'https://www.youtube.com/watch?v=g1OOjNPQb0g'
    },
    {
      id: 7,
      title: 'Group Dance At Kalpita Technologies',
      thumbnail: 'https://img.youtube.com/vi/atbm6-8EWO8/hqdefault.jpg',
      video: 'https://www.youtube.com/watch?v=atbm6-8EWO8'
    },
    {
      id: 8,
      title: 'Kalpita Technologies 2024 Rewind: Reliving the Best of 2024',
      thumbnail: 'https://img.youtube.com/vi/XCTHZzU4SSk/maxresdefault.jpg',
      video: 'https://www.youtube.com/watch?v=XCTHZzU4SSk&t=8s'
    },
    // {
    //   id: 9,
    //   title: 'Kalpita Technologies 7th Anniversary Celebrations Highlights',
    //   thumbnail: 'https://img.youtube.com/vi/Ml0K_FKguI4/maxresdefault.jpg',
    //   video: 'https://www.youtube.com/watch?v=Ml0K_FKguI4'
    // },
    // {
    //   id: 10,
    //   title: 'Kalpita Technologies 2024 Rewind: Reliving the Best of 2024',
    //   thumbnail: 'https://img.youtube.com/vi/XCTHZzU4SSk/maxresdefault.jpg',
    //   video: 'https://www.youtube.com/watch?v=XCTHZzU4SSk&t=8s'
    // },
    // {
    //   id: 11,
    //   title: 'SPARK The Best Moments of 2024! Can You Spot Yourself',
    //   thumbnail: 'https://img.youtube.com/vi/7kfUTOdvimw/hqdefault.jpg',
    //   video: 'https://www.youtube.com/watch?v=7kfUTOdvimw&t=6s'
    // },
    // {
    //   id: 12,
    //   title: 'Kalpita Technologies 7th Anniversary Celebrations Highlights',
    //   thumbnail: 'https://img.youtube.com/vi/Ml0K_FKguI4/maxresdefault.jpg',
    //   video: 'https://www.youtube.com/watch?v=Ml0K_FKguI4'
    // },
    // {
    //   id: 13,
    //   title: 'Kalpita Technologies 7th Anniversary Celebrations Highlights',
    //   thumbnail: 'https://img.youtube.com/vi/Ml0K_FKguI4/maxresdefault.jpg',
    //   video: 'https://www.youtube.com/watch?v=Ml0K_FKguI4'
    // },
    // {
    //   id: 14,
    //   title: 'Kalpita Technologies 2024 Rewind: Reliving the Best of 2024',
    //   thumbnail: 'https://img.youtube.com/vi/XCTHZzU4SSk/maxresdefault.jpg',
    //   video: 'https://www.youtube.com/watch?v=XCTHZzU4SSk&t=8s'
    // },
    // {
    //   id: 15,
    //   title: 'SPARK The Best Moments of 2024! Can You Spot Yourself',
    //   thumbnail: 'https://img.youtube.com/vi/7kfUTOdvimw/hqdefault.jpg',
    //   video: 'https://www.youtube.com/watch?v=7kfUTOdvimw&t=6s'
    // },
    // {
    //   id: 16,
    //   title: 'Kalpita Technologies 2024 Rewind: Reliving the Best of 2024',
    //   thumbnail: 'https://img.youtube.com/vi/XCTHZzU4SSk/maxresdefault.jpg',
    //   video: 'https://www.youtube.com/watch?v=XCTHZzU4SSk&t=8s'
    // }
  ];

  // ==================== SHORTS SECTION (Thumbnails extracted from YouTube URLs) ====================
  shortsVideos: Video[] = [
    {
      id: 1,
      title: 'Year-End Celebration 2025',
      thumbnail: 'https://img.youtube.com/vi/7lXOvjDZ15s/maxresdefault.jpg',
      video: 'https://youtube.com/shorts/7lXOvjDZ15s?si=9n4UnhjrZ4aydCXN'
    },
    {
      id: 2,
      title: 'Kalpita CSR Highlights',
      thumbnail: 'https://img.youtube.com/vi/W_4CXUCEIco/maxresdefault.jpg',
      video: 'https://youtube.com/shorts/W_4CXUCEIco?si=kreYGsxK_35w5S2y'
    },
    {
      id: 3,
      title: 'Anniversary Special Awards 2025',
      thumbnail: 'https://img.youtube.com/vi/NRNNMd6hq60/maxresdefault.jpg',
      video: 'https://youtu.be/NRNNMd6hq60?si=Co4XAKxv0GJWYEdF'
    },
    {
      id: 4,
      title: 'Anniversary Longevity Awards 2025',
      thumbnail: 'https://img.youtube.com/vi/mRm_HPTxe9Y/maxresdefault.jpg',
      video: 'https://youtu.be/mRm_HPTxe9Y?si=NLSOzt1jQgGWoCl6'
    },
    {
      id: 5,
      title: "Kalpita's 7-Year Journey",
      thumbnail: 'https://img.youtube.com/vi/-L7l4BwsK_Q/maxresdefault.jpg',
      video: 'https://youtu.be/-L7l4BwsK_Q?si=iEuZArCMf8-HPOVH'
    },
    {
      id: 6,
      title: 'Next-Gen Leadership Training',
      thumbnail: 'https://img.youtube.com/vi/Nanf3EIniHI/maxresdefault.jpg',
      video: 'https://youtu.be/Nanf3EIniHI?si=Gr-sN4zdWmVlMmga'
    },
    {
      id: 7,
      title: '6 Years of Partnership',
      thumbnail: 'https://img.youtube.com/vi/W84abe2ciTE/maxresdefault.jpg',
      video: 'https://youtu.be/W84abe2ciTE?si=XbUxxrX6v66bLewo'
    }
  ];

  // Gallery section
  galleryImages: GalleryImage[] = [
    { id: 1, src: 'assets/gallery-page/life-at-kalpita/images/republicday.jpg', alt: 'Republic Day Celebration', caption: 'Republic Day Celebration' },
    { id: 2, src: 'assets/gallery-page/life-at-kalpita/images/sankranthiceleb.jpg', alt: 'Sankranti Celebration 2026', caption: 'Sankranti Celebration 2026' },
    { id: 3, src: 'assets/gallery-page/life-at-kalpita/images/kalpitawithnfp.jpg', alt: 'Kalpita Team with NFP', caption: 'Kalpita Team with NFP' },
    { id: 4, src: 'assets/gallery-page/life-at-kalpita/images/ourkalpitateam.jpg', alt: 'Our Kalpita Team', caption: 'Our Kalpita Team' },
    { id: 5, src: 'assets/gallery-page/life-at-kalpita/images/seventhanniversary.png', alt: '7th Anniversary Celebration', caption: '7th Anniversary Celebration' },
    { id: 6, src: 'assets/gallery-page/life-at-kalpita/images/opclientvisit.jpg', alt: 'OP Client Visit', caption: 'OP Client Visit' },
    { id: 7, src: 'assets/gallery-page/life-at-kalpita/images/nfpclientvisit.png', alt: 'NFP Client Visit', caption: 'NFP Client Visit' },
    { id: 8, src: 'assets/gallery-page/life-at-kalpita/images/refugeefoundation-csr.jpg', alt: 'CSR at Refugee Foundation', caption: 'CSR at Refugee Foundation' },
  ];

  // ==================== STATE VARIABLES ====================
  trainingCurrentCenterIndex = 0;
  trainingVisibleCount = 8;
  showVideoModal = false;
  currentModalVideo: Video | null = null;

  // Shorts section - Using home page gallery logic
  shortsCurrentCenterIndex = 0;
  currentSlideShorts: Video[] = [];
  shortsDotCount = 0;
  showShortsModal = false;
  currentShortsModalVideo: Video | null = null;
  shortsItemsPerSlide = 5;
  shortsCenterOffset = 2;

  // Images section
  galleryCurrentCenterIndex = 0;
  galleryVisibleCount = 8;
  showImageModal = false;
  currentModalImage: GalleryImage | null = null;

  constructor(private sanitizer: DomSanitizer, private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document) { }

  // ==================== INIT ====================
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.processVideoUrls();
    this.updateTrainingVisibleCount();
    this.checkShortsScreenSize();
    this.calculateShortsDots();
    this.updateShortsSlide();
    this.updateGalleryVisibleCount();

    window.addEventListener('resize', () => {
      this.updateTrainingVisibleCount();
      this.checkShortsScreenSize();
      this.updateGalleryVisibleCount();
    });
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }

  injectSchemaMarkup(): void {
    const lifeAtKalpitaSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita",
          "url": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita",
          "name": "Life At Kalpita — Kalpita Technologies",
          "description": "Experience the vibrant culture at Kalpita Technologies through curated shorts, videos, and photo galleries showcasing team building activities, anniversary celebrations, cultural events, CSR initiatives, the Future Coders program, FUN RUN events, client visits, SPARK highlights, and the people-first workplace that makes Kalpita a Great Place to Work.",
          "speakable": {
            "@type": "SpeakableSpecification",
            "cssSelector": [
              ".life-heading",
              ".life-subheading",
              ".shorts-heading",
              ".videos-heading",
              ".section-title"
            ]
          },
          "datePublished": "2024-01-01",
          "dateModified": "2025-06-01",
          "isPartOf": {
            "@type": "WebSite",
            "@id": "https://www.kalpitatechnologies.com/#website",
            "name": "Kalpita Technologies",
            "url": "https://www.kalpitatechnologies.com/"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita#breadcrumb",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "WebPage",
                "@id": "https://www.kalpitatechnologies.com/",
                "url": "https://www.kalpitatechnologies.com/",
                "name": "Home"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "WebPage",
                "@id": "https://www.kalpitatechnologies.com/gallery",
                "url": "https://www.kalpitatechnologies.com/gallery",
                "name": "Gallery"
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "WebPage",
                "@id": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita",
                "url": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita",
                "name": "Life At Kalpita"
              }
            }
          ]
        },
        {
          "@type": "TechArticle",
          "headline": "Life At Kalpita: Inside the Culture, Celebrations, and Community of Kalpita Technologies",
          "alternativeHeadline": "Shorts, Videos, and Photo Gallery Showcasing Team Building, Anniversary Celebrations, CSR, Future Coders, and People-First Workplace Culture",
          "backstory": "Life At Kalpita is the company's multimedia gallery page showcasing the vibrant workplace culture at Kalpita Technologies. Through curated YouTube shorts, full-length videos, and photo galleries, the page captures team building activities, anniversary celebrations from the 6th and 7th year milestones, cultural performances, CSR initiatives, client visit activities, and the energy of the people who make Kalpita a certified Great Place to Work.",
          "proficiencyLevel": "Beginner",
          "dependencies": "Interest in workplace culture, corporate social responsibility, team building activities, employee engagement events, company anniversary celebrations, and technology company culture in India",
          "articleBody": "Life At Kalpita showcases the vibrant workplace culture at Kalpita Technologies through three multimedia sections: Shorts, Videos, and Images. The Shorts section features bite-sized vertical video content including Epic Office Team Building Activities capturing collaborative games and challenges, 6 Years of Excellence celebrating the company's sixth anniversary milestone, CSR in Action highlighting corporate social responsibility initiatives and community engagement, Future Coders Made It showcasing the freshers batch program achievements, Office Celebrations capturing festival and milestone moments, and Team Building Fun documenting employee bonding activities. The Videos section features full-length content including Kalpita Technologies 7th Anniversary Celebrations Highlights capturing the milestone event, 2025 Recap Corporate Life and Culture Wrap Up reviewing the year's achievements, SPARK The Best Moments of 2024 showcasing workplace highlights, Client Visit 2022 Cultural Activities documenting client engagement events, Kalpita Technologies Wishes Happy Sankranti celebrating Indian festivals, Kalpita FUN RUN 2022 featuring employee fitness and team spirit events, Group Dance At Kalpita Technologies showcasing cultural performances, and Kalpita Technologies 2024 Rewind reliving the year's best moments. The Images section presents a photo gallery of the 7th Anniversary Celebration with sixteen curated photographs capturing the event's energy, team spirit, and celebrations. All video content is hosted on YouTube with interactive carousel navigation, thumbnail previews, and full-screen modal playback. The gallery showcases the people-first culture that has earned Kalpita Technologies recognition as a Great Place to Work for multiple consecutive years, reflecting the company's core values of innovation, agility, empathy, excellence, and integrity.",
          "keywords": [
            "Life At Kalpita", "Kalpita Technologies culture", "workplace culture gallery", "team building activities", "7th anniversary celebration", "corporate culture videos", "CSR initiatives", "Future Coders program", "office celebrations", "FUN RUN event", "employee engagement", "cultural performances", "SPARK highlights 2024", "client visit activities", "people-first workplace", "Great Place to Work culture", "YouTube shorts corporate", "Kalpita Technologies events", "workplace photo gallery", "company anniversary highlights"
          ],
          "author": { "@type": "Organization", "name": "Kalpita Technologies" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": {
              "@type": "ImageObject",
              "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png"
            }
          },
          "datePublished": "2024-01-01",
          "dateModified": "2025-06-01",
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita"
          },
          "additionalProperty": [
            {
              "@type": "PropertyValue",
              "name": "Shorts — Bite-Sized Culture Highlights",
              "value": "Six YouTube Shorts capturing the essence of Kalpita's culture: Epic Office Team Building Activities, 6 Years of Excellence anniversary celebration, CSR in Action community engagement, Future Coders Made It freshers program achievements, Office Celebrations for festivals and milestones, and Team Building Fun employee bonding activities."
            },
            {
              "@type": "PropertyValue",
              "name": "Videos — Full-Length Culture and Event Content",
              "value": "Eight full-length YouTube videos including 7th Anniversary Celebrations Highlights, 2025 Recap Corporate Culture Wrap Up, SPARK Best Moments of 2024, Client Visit 2022 Cultural Activities, Happy Sankranti wishes, FUN RUN 2022, Group Dance performances, and 2024 Rewind reliving the year's best moments."
            },
            {
              "@type": "PropertyValue",
              "name": "Images — 7th Anniversary Photo Gallery",
              "value": "Sixteen curated photographs from the Kalpita Technologies 7th Anniversary Celebration capturing team spirit, event energy, and workplace celebrations. The gallery features interactive carousel navigation with modal viewing for full-size image display."
            },
            {
              "@type": "PropertyValue",
              "name": "TL;DR",
              "value": "Life At Kalpita is the multimedia gallery showcasing Kalpita Technologies' workplace culture through 6 YouTube Shorts (team building, CSR, Future Coders, celebrations), 8 full-length videos (7th anniversary, 2024/2025 recaps, SPARK, FUN RUN, cultural performances), and 16 photo gallery images from the 7th Anniversary Celebration."
            }
          ]
        },
        {
          "@type": "ItemList",
          "@id": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita#sections",
          "name": "Gallery Sections",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "Article", "name": "Shorts — Team Building, CSR, Future Coders, and Celebrations", "url": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita#shorts" } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "Article", "name": "Videos — Anniversary Highlights, Recaps, and Cultural Events", "url": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita#videos" } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "Article", "name": "Images — 7th Anniversary Celebration Photo Gallery", "url": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita#images" } },
            { "@type": "ListItem", "position": 4, "item": { "@type": "Article", "name": "People-First Culture and Great Place to Work Recognition", "url": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita#culture" } },
            { "@type": "ListItem", "position": 5, "item": { "@type": "Article", "name": "Employee Engagement — FUN RUN, SPARK, and Festival Celebrations", "url": "https://www.kalpitatechnologies.com/gallery/life-at-kalpita#engagement" } }
          ]
        },
        {
          "@type": "HowTo",
          "name": "How to Showcase Workplace Culture Like Kalpita Technologies' Life At Kalpita",
          "description": "Step-by-step guide to building a compelling multimedia gallery that showcases company culture, team events, and people-first values.",
          "step": [
            { "@type": "HowToStep", "name": "Create Bite-Sized Shorts for Quick Culture Highlights", "text": "Produce short vertical videos capturing everyday culture moments. Kalpita Technologies features six YouTube Shorts covering team building activities, CSR initiatives, Future Coders freshers program achievements, office celebrations, and employee bonding events that give viewers a quick glimpse into the company's energy and values." },
            { "@type": "HowToStep", "name": "Produce Full-Length Videos for Major Events and Recaps", "text": "Create comprehensive videos for milestone celebrations and annual reviews. Kalpita's video section includes 7th Anniversary Celebration highlights, annual recaps for 2024 and 2025, SPARK Best Moments compilation, client visit cultural activities, festival celebrations like Sankranti, FUN RUN fitness events, and cultural dance performances." },
            { "@type": "HowToStep", "name": "Build a Photo Gallery for Visual Event Documentation", "text": "Curate high-quality photographs from major company events. Kalpita Technologies presents sixteen photos from its 7th Anniversary Celebration with interactive carousel navigation and modal viewing, capturing team spirit, event atmosphere, and the people behind the company's success." },
            { "@type": "HowToStep", "name": "Host Content on YouTube with Interactive On-Site Playback", "text": "Publish video content on YouTube for broad reach and embed it on your website with interactive features. Kalpita uses carousel navigation with dot indicators, thumbnail previews with play overlays, and full-screen modal playback for both shorts and regular videos, creating a seamless viewing experience." },
            { "@type": "HowToStep", "name": "Reflect Core Values Through Every Piece of Content", "text": "Ensure all gallery content reinforces your company's values and culture. Kalpita Technologies' Life At Kalpita page reflects its core values of innovation, agility, empathy, excellence, and integrity through content that highlights CSR engagement, employee development programs like Future Coders, team bonding, and the people-first culture that earns Great Place to Work recognition." }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            { "@type": "Question", "name": "What is the Life At Kalpita page?", "acceptedAnswer": { "@type": "Answer", "text": "Life At Kalpita is Kalpita Technologies' multimedia gallery page showcasing the company's vibrant workplace culture. It features three sections: Shorts with six bite-sized YouTube videos, Videos with eight full-length YouTube recordings, and Images with sixteen photographs from the 7th Anniversary Celebration, all presented with interactive carousel navigation and modal playback." } },
            { "@type": "Question", "name": "What shorts are featured on the Life At Kalpita page?", "acceptedAnswer": { "@type": "Answer", "text": "The Shorts section features six YouTube vertical videos: Epic Office Team Building Activities capturing collaborative challenges, 6 Years of Excellence celebrating the sixth anniversary milestone, CSR in Action highlighting community engagement, Future Coders Made It showcasing freshers program achievements, Office Celebrations capturing festival moments, and Team Building Fun documenting employee bonding activities." } },
            { "@type": "Question", "name": "What videos showcase Kalpita Technologies' culture?", "acceptedAnswer": { "@type": "Answer", "text": "Eight full-length videos showcase the company culture: Kalpita Technologies 7th Anniversary Celebrations Highlights, 2025 Recap Corporate Life and Culture Wrap Up, SPARK The Best Moments of 2024, Client Visit 2022 Cultural Activities, Happy Sankranti festival wishes, Kalpita FUN RUN 2022 fitness event, Group Dance At Kalpita Technologies cultural performances, and Kalpita Technologies 2024 Rewind." } },
            { "@type": "Question", "name": "What does the Images gallery section contain?", "acceptedAnswer": { "@type": "Answer", "text": "The Images section presents a photo gallery with sixteen curated photographs from the Kalpita Technologies 7th Anniversary Celebration. The gallery features interactive carousel navigation with eight images per slide on desktop, four on tablet, and two on mobile, with dot indicators and modal viewing for full-size image display." } },
            { "@type": "Question", "name": "What is the Future Coders program shown in the shorts?", "acceptedAnswer": { "@type": "Answer", "text": "Future Coders is Kalpita Technologies' freshers batch program that hires fresh graduates and nurtures them with rigorous training in the latest technologies, certifications, and mentorship to grow into leadership roles. The shorts section features a video titled Future Coders Made It celebrating the achievements and success of participants in this talent development initiative." } },
            { "@type": "Question", "name": "How does the Life At Kalpita page reflect the company's culture?", "acceptedAnswer": { "@type": "Answer", "text": "The page reflects Kalpita Technologies' people-first culture through content highlighting team building, CSR community engagement, employee development programs, festival celebrations, fitness events, cultural performances, and anniversary milestones. This culture has earned the company Great Place to Work recognition for multiple consecutive years, built on core values of innovation, agility, empathy, excellence, and integrity." } }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png"
          },
          "foundingDate": "2018",
          "address": [
            {
              "@type": "PostalAddress",
              "streetAddress": "Suite #300, 3rd Floor, Building 2, 1250 South Capital of Texas Highway",
              "addressLocality": "Austin", "addressRegion": "TX", "postalCode": "78746", "addressCountry": "US"
            },
            {
              "@type": "PostalAddress",
              "streetAddress": "4M 417/A, 4th Floor, HRBR Layout 3rd Block, Kammanahalli Main Road",
              "addressLocality": "Bengaluru", "addressRegion": "Karnataka", "postalCode": "560043", "addressCountry": "IN"
            }
          ],
          "contactPoint": [
            { "@type": "ContactPoint", "telephone": "+1-512-240-2484", "contactType": "sales", "areaServed": "US" },
            { "@type": "ContactPoint", "telephone": "+91-9535-040-880", "contactType": "sales", "areaServed": "IN" }
          ],
          "sameAs": [
            "https://www.linkedin.com/company/kalpita-technologies/",
            "https://www.instagram.com/kalpitatechnologies/",
            "https://x.com/kaboratech",
            "https://www.facebook.com/KalpitaTechnologies/",
            "https://www.youtube.com/@KalpitaTechnologies"
          ]
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.kalpitatechnologies.com/#localbusiness",
          "name": "Kalpita Technologies — Austin Office",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Suite #300, 3rd Floor, Building 2, 1250 South Capital of Texas Highway",
            "addressLocality": "Austin", "addressRegion": "TX", "postalCode": "78746", "addressCountry": "US"
          },
          "telephone": "+1-512-240-2484",
          "url": "https://www.kalpitatechnologies.com/",
          "sameAs": [
            "https://www.linkedin.com/company/kalpita-technologies/",
            "https://www.instagram.com/kalpitatechnologies/",
            "https://x.com/kaboratech",
            "https://www.facebook.com/KalpitaTechnologies/",
            "https://www.youtube.com/@KalpitaTechnologies"
          ],
          "email": "info@kalpitatechnologies.com",
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "18:00"
          }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(lifeAtKalpitaSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  get showTrainingCarousel(): boolean {
    return this.trainingVideos.length > this.trainingVisibleCount;
  }

  // ==================== SHORTS CAROUSEL (Home Page Gallery Logic) ====================

  // REQUIRED for smooth transitions
  trackByVideoId(index: number, video: Video): number {
    return video.id;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkShortsScreenSize();
  }

  checkShortsScreenSize() {
    const width = window.innerWidth;

    // Switch to 3 items below 992px (Tablet Portrait & Mobile)
    if (width < 992) {
      if (this.shortsItemsPerSlide !== 3) {
        this.shortsItemsPerSlide = 3;
        this.shortsCenterOffset = 1;
        this.calculateShortsDots();
        this.updateShortsSlide();
      }
    } else {
      // 5 items for Desktop/Landscape Tablet
      if (this.shortsItemsPerSlide !== 5) {
        this.shortsItemsPerSlide = 5;
        this.shortsCenterOffset = 2;
        this.calculateShortsDots();
        this.updateShortsSlide();
      }
    }
  }

  calculateShortsDots() {
    this.shortsDotCount = Math.ceil(this.shortsVideos.length / this.shortsItemsPerSlide);
  }

  updateShortsSlide(): void {
    const len = this.shortsVideos.length;
    this.currentSlideShorts = [];

    // Calculate the slice around the center index with wrapping
    for (let i = -this.shortsCenterOffset; i <= this.shortsCenterOffset; i++) {
      const idx = (this.shortsCurrentCenterIndex + i + len) % len;
      this.currentSlideShorts.push(this.shortsVideos[idx]);
    }
  }

  onShortsThumbnailClick(idx: number): void {
    const centerPosition = this.shortsCenterOffset;

    if (idx === centerPosition) {
      // Clicked CENTER -> PLAY
      this.currentShortsModalVideo = this.currentSlideShorts[idx];
      this.showShortsModal = true;
      document.body.style.overflow = 'hidden';
    } else {
      // Clicked SIDE -> ANIMATE TO CENTER
      const offset = idx - centerPosition;
      this.shortsCurrentCenterIndex = (this.shortsCurrentCenterIndex + offset + this.shortsVideos.length) % this.shortsVideos.length;
      this.updateShortsSlide();
    }
  }

  getShortsVideoSizeClass(idx: number): string {
    const center = this.shortsCenterOffset;

    // The Center Item
    if (idx === center) return 'shorts-item-large active';

    // 5-Item Mode (Desktop)
    if (this.shortsItemsPerSlide === 5) {
      if (idx === 1 || idx === 3) return 'shorts-item-medium';
    }

    // 3-Item Mode (Mobile/Tablet)
    // The side items (indices 0 and 2) become 'medium' sized logic
    if (this.shortsItemsPerSlide === 3) {
      return 'shorts-item-medium';
    }

    return 'shorts-item-small';
  }

  getShortsActiveDot(): number {
    return Math.floor(this.shortsCurrentCenterIndex / this.shortsItemsPerSlide);
  }

  onShortsDotClick(dotIndex: number) {
    const targetIndex = (dotIndex * this.shortsItemsPerSlide) % this.shortsVideos.length;
    this.shortsCurrentCenterIndex = targetIndex;
    this.updateShortsSlide();
  }

  closeShortsModal(): void {
    this.showShortsModal = false;
    this.currentShortsModalVideo = null;
    document.body.style.overflow = 'auto';
  }

  // ==================== VIDEO PROCESSING ====================
  private processVideoUrls(): void {
    const videoArrays = [this.trainingVideos, this.shortsVideos];
    videoArrays.forEach(videoArray => {
      videoArray.forEach(v => {
        const videoId = this.extractYouTubeId(v.video);
        if (videoId) {
          v.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`
          );
        }
      });
    });
  }

  private extractYouTubeId(url: string): string | null {
    if (!url) return null;

    const shortsMatch = url.match(/(?:youtube\.com\/shorts\/|youtu\.be\/shorts\/)([\w-]+)/);
    if (shortsMatch) return shortsMatch[1];

    const patterns = [
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/,
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/,
      /(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})/
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1] && match[1].length === 11) return match[1];
    }
    return null;
  }

  // ==================== TRAINING VIDEOS ====================
  updateTrainingVisibleCount(): void {
    const width = window.innerWidth;
    if (width <= 576) this.trainingVisibleCount = 2;
    else if (width <= 992) this.trainingVisibleCount = 4;
    else this.trainingVisibleCount = 8;
  }

  get trainingSlideVideos(): Video[] {
    return this.trainingVideos.slice(
      this.trainingCurrentCenterIndex,
      this.trainingCurrentCenterIndex + this.trainingVisibleCount
    );
  }

  get trainingDotCount(): number {
    return Math.ceil(this.trainingVideos.length / this.trainingVisibleCount);
  }

  onTrainingDotClick(dotIndex: number): void {
    const newIndex = dotIndex * this.trainingVisibleCount;
    const maxStart = Math.max(0, this.trainingVideos.length - this.trainingVisibleCount);
    this.trainingCurrentCenterIndex = Math.min(newIndex, maxStart);
  }

  trainingSlide(direction: 'prev' | 'next'): void {
    if (!this.showTrainingCarousel) return;

    const starts = this.getPageStarts(this.trainingVideos.length, this.trainingVisibleCount);
    const idx = this.getCurrentPageIndex(starts, this.trainingCurrentCenterIndex);
    const newIdx =
      direction === 'prev'
        ? Math.max(0, idx - 1)
        : Math.min(starts.length - 1, idx + 1);

    this.trainingCurrentCenterIndex = starts[newIdx];
  }

  // ==================== VIDEO MODAL ====================
  openVideoModal(video: Video): void {
    if (video && video.safeUrl) {
      this.currentModalVideo = video;
      this.showVideoModal = true;
      document.body.style.overflow = 'hidden';
    }
  }

  closeVideoModal(): void {
    this.showVideoModal = false;
    this.currentModalVideo = null;
    document.body.style.overflow = 'auto';
  }

  // ==================== GALLERY ====================
  updateGalleryVisibleCount(): void {
    // If 8 or fewer images → show all, no carousel
    if (this.galleryImages.length <= 8) {
      this.galleryVisibleCount = this.galleryImages.length;
      this.galleryCurrentCenterIndex = 0;
      return;
    }

    // Only when more than 8 images
    const width = window.innerWidth;
    if (width <= 480) this.galleryVisibleCount = 2;
    else if (width <= 768) this.galleryVisibleCount = 4;
    else this.galleryVisibleCount = 8;
  }

  get showGalleryCarousel(): boolean {
    return this.galleryImages.length > 8;
  }

  get gallerySlideImages(): GalleryImage[] {
    return this.galleryImages.slice(this.galleryCurrentCenterIndex, this.galleryCurrentCenterIndex + this.galleryVisibleCount);
  }

  get galleryDotCount(): number {
    return Math.ceil(this.galleryImages.length / this.galleryVisibleCount);
  }

  onGalleryDotClick(dotIndex: number): void {
    const newIndex = dotIndex * this.galleryVisibleCount;
    const maxStart = Math.max(0, this.galleryImages.length - this.galleryVisibleCount);
    this.galleryCurrentCenterIndex = Math.min(newIndex, maxStart);
  }

  gallerySlide(direction: 'prev' | 'next'): void {
    if (!this.showGalleryCarousel) return;

    const starts = this.getPageStarts(this.galleryImages.length, this.galleryVisibleCount);
    const idx = this.getCurrentPageIndex(starts, this.galleryCurrentCenterIndex);
    const newIdx =
      direction === 'prev'
        ? Math.max(0, idx - 1)
        : Math.min(starts.length - 1, idx + 1);

    this.galleryCurrentCenterIndex = starts[newIdx];
  }

  openImageModal(img: GalleryImage): void {
    if (img) {
      this.currentModalImage = img;
      this.showImageModal = true;
      document.body.style.overflow = 'hidden';
    }
  }

  closeImageModal(): void {
    this.showImageModal = false;
    this.currentModalImage = null;
    document.body.style.overflow = 'auto';
  }

  @HostListener('document:keydown.escape')
  onEsc(): void {
    if (this.showVideoModal) this.closeVideoModal();
    if (this.showShortsModal) this.closeShortsModal();
    if (this.showImageModal) this.closeImageModal();
  }

  // ==================== HELPERS ====================
  formatTitle(title: string): string {
    if (!title) return '';
    return title.replace(/#(\w+)/g, '<span class="hashtag">#$1</span>');
  }

  private getPageStarts(totalItems: number, perPage: number): number[] {
    const starts: number[] = [];
    const maxStart = Math.max(0, totalItems - perPage);
    for (let i = 0; i * perPage < totalItems; i++) {
      const start = Math.min(i * perPage, maxStart);
      if (starts.length === 0 || starts[starts.length - 1] !== start) {
        starts.push(start);
      }
    }
    return starts;
  }

  private getCurrentPageIndex(starts: number[], current: number): number {
    const exact = starts.indexOf(current);
    if (exact !== -1) return exact;
    for (let i = 0; i < starts.length; i++) {
      if (starts[i] > current) return Math.max(0, i - 1);
    }
    return Math.max(0, starts.length - 1);
  }

  createArray(n: number): number[] {
    return Array.from({ length: Math.max(0, n) }, (_, i) => i);
  }
}